module.exports = __webpack_public_path__ + "static/media/ktm-15.7bfb7b7d.png";